import LeadSquaredReaderNode from './types/lead-squared-reader';
import LeadSquaredWriterNode from './types/lead-squared-writer';

export const leadSquaredNodes = {
  leadSquaredReader: LeadSquaredReaderNode,
  leadSquaredWriter: LeadSquaredWriterNode,
};
